<template>
  <v-footer
    v-if="showFormButtons"
    padless
    fixed
    outlined
    class="pl-5 pr-5 pt-3 pb-3"
    color="white"
    elevation="3"
  >
    <v-btn v-if="isDataExist && !isEditMode" outlined color="error" class="mr-4" @click="onDelete"
      >Delete data</v-btn
    >

    <div class="calculateBtn">
      <v-btn outlined color="primary" class="mr-4" @click="onCalculate"
        >Calculate</v-btn
      >
      <v-btn v-if="showViewResults" class="mr-4" outlined color="primary" @click="onViewResults">
        View results
      </v-btn>
      <v-btn v-if="showQuoteButton" outlined color="primary" @click="onQuote">Quote</v-btn>
    </div>
    <v-spacer></v-spacer>
    <div>
      <v-btn v-if="!isEditMode" outlined color="primary" class="ml-4" @click="onEdit"
        >Edit fields</v-btn
      >
      <v-btn v-if="!isEditMode" outlined color="primary" class="ml-4" @click="onAdd"
        >Add</v-btn
      >

      <v-btn v-if="isEditMode" outlined color="primary" class="ml-4" @click="onCancel"
        >Cancel changes</v-btn
      >
      <v-btn
        v-if="isEditMode"
        depressed
        color="primary"
        class="ml-4"
        :disabled="!isFormValid"
        @click="onSave"
        >Save changes</v-btn
      >
    </div>
  </v-footer>
</template>

<script>
export default {
  name: 'LeaversBtns',
  components: {},
  props: {
    isDataExist: Boolean,
    isEditMode: Boolean,
    showFormButtons: Boolean,
    showViewResults: Boolean,
    showQuoteButton: Boolean,
    isFormValid: Boolean,
  },

  data() {
    return {};
  },

  computed: {},
  created() {},
  methods: {
    onCancel() {
      this.$emit('buttonClick', 'cancel');
    },
    onSave() {
      this.$emit('buttonClick', 'save');
    },
    onDelete() {
      this.$emit('buttonClick', 'delete');
    },
    onEdit() {
      this.$emit('buttonClick', 'edit');
    },
    onCalculate() {
      this.$emit('buttonClick', 'calculate');
    },
    onViewResults() {
      this.$emit('buttonClick', 'viewResults');
    },
    onQuote() {
      this.$emit('buttonClick', 'quote');
    },
    onAdd(){
      this.$emit('buttonClick', 'add');
    }
  },
};
</script>

<style></style>
